import * as React from "react";
import { BooleanField, Datagrid, FunctionField, TextField } from "react-admin";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { AcceptColumn } from "./AcceptColumn";
import { formatDate } from "../../../../Helper/MomentHelper";

export const DataGridColumns = props => {
  return (
    <Datagrid {...props} optimized hasBulkActions={false}>
      <AcceptColumn label="Actions" remarkAddClick={props.remarkAddClick} />
      <BooleanField label="Rdd Delayed" source="isRddDelayed" />
      <TextField source="refNo" label="Ref No" />
      <TextField source="customer" label="Customer" />
      <TextField source="customerPo" label="Customer PO" />
      <TextField source="pn" label="PN" />
      <TextField source="pnDescription" label="PN Description" />
      <TextField source="sn" label="SN" />
      <TextField source="wo" label="WO" />
      <TextField source="ro" label="RO" />
      <TextField source="workShop" label="WorkShop" />
      <TextField source="woInprogressStatus" label="WO Inprogress Status" />
      <FunctionField
        label="Requested Delivery Date"
        sortBy="clockCreatedDate"
        render={(record: any) =>
          record.requestedDeliveryDate === null
            ? "Not Arrived Yet"
            : formatDate(record.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
              ? "Exclude"
              : formatDate(record.requestedDeliveryDate, false)
        }
      />
      <CustomDateField source="woCreatedDate" label="WO Created Date" showTime />
      <TextField source="shopRemark" label="Shop Remarks" />
    </Datagrid>
  );
};

export default DataGridColumns;
